import * as React from "react";

const OrderingTools: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="34" viewBox="0 0 32 34">
            <g fill="none" fillRule="evenodd">
                <g fill="#002856" fillRule="nonzero">
                    <g>
                        <g>
                            <path
                                d="M31.79 13.334v-.07c-.015-.12-.055-.231-.114-.335v-.052l-3.508-5.264h-.002c-.161-.264-.452-.425-.763-.42h-3.508c-.485 0-.877.393-.877.878 0 .483.392.876.877.876h3.034l2.342 3.509H2.73L5.07 8.947h3.034c.485 0 .877-.393.877-.876 0-.485-.392-.879-.877-.879H4.597c-.294.002-.567.15-.729.395L.36 12.85v.053c-.06.104-.098.215-.115.334v19.395c0 .232.094.455.258.62.165.164.387.256.62.256h29.79c.232 0 .455-.092.62-.256.164-.165.257-.388.257-.62V13.334zm-1.755 18.42H1.965V14.212h28.07v17.544z"
                                transform="translate(-149 -566) translate(80 540) translate(69 26)"
                            />
                            <path
                                d="M15.377 10.447c.164.166.39.26.623.26.234 0 .46-.094.624-.26l3.508-3.508c.344-.344.344-.903 0-1.247-.344-.343-.902-.343-1.245 0l-2.01 2.018V1.053c0-.486-.392-.877-.877-.877s-.876.391-.876.877V7.71l-2.009-2.018h-.001c-.344-.343-.902-.343-1.245 0-.344.344-.344.903 0 1.247l3.508 3.508zM23.895 28.245h1.755c.483 0 .876-.391.876-.877 0-.485-.393-.876-.876-.876h-1.755c-.485 0-.877.391-.877.876 0 .486.392.877.877.877z"
                                transform="translate(-149 -566) translate(80 540) translate(69 26)"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(OrderingTools);
